import { createApolloClient } from './clientGenerator';
const graphqlClient = (() => {
    const clients = [];
    const setUpClients = (clientUrls) => {
        clientUrls.forEach((clientOptions) => {
            clients[clientOptions.name] = createApolloClient(clientOptions);
        });
        return clients;
    };
    const setTokens = (tenantId, incomingTokens) => {
        incomingTokens.forEach((c, i) => {
            clients[c.name].setAuthToken(tenantId, c.tokens);
        });
    };
    const getClient = (name) => {
        return clients[name] && clients[name];
    };
    return {
        setUpClients,
        getClient,
        setTokens,
    };
})();
export default graphqlClient;
//# sourceMappingURL=clientConfiguration.js.map